import React from 'react';
import { mergeClasses, Spinner, Text } from '@fluentui/react-components';

import { useStyles } from '../styles/no-data';

export function NoData({ i18n, isLoading = false, size }: {
  i18n: { getString: (key: string) => string },
  isLoading?: boolean,
  size?: 'small' | 'medium' | 'large',
}) {
  const classes = useStyles();
  return (
    <div className={mergeClasses('error-container', classes.errorContainer)}>
      {isLoading ? (
        <div className={mergeClasses('loading-container', classes.loadingContainer, size === 'small' && classes.loadingContainerSmall)}>
          <Spinner
            label={i18n.getString(_TL_('Generating insights...'))}
            labelPosition="below"
            size={size === 'small' ? 'tiny' : 'medium'}
          />
        </div>
      ) : (
        <div className={mergeClasses('no-data-container', classes.noDataContainer)}>
          <Text>{i18n.getString(_TL_('We are unable to display the graph at this time. Please try again later.'))}</Text>
        </div>
      )}
    </div>
  );
}
